import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import Home from "./Home";
import About from "./About";
import LandingPageContent from "./ExamModesMarketing";
import ExamsSeciton from "./ExamsSeciton";
import StatisticsSection from "./StatisticsSection";
import Reviews from "./Reviews";
import Blogs from "./Blogs";

function LandingPage({ loading: initialLoading, exams: initialExams }) {
  const [loading, setLoading] = useState(initialLoading);
  const [exams, setExams] = useState(initialExams);

  useEffect(() => {
    setLoading(initialLoading);
    setExams(initialExams);
  }, [initialLoading, initialExams]);

  return (
    <>
      <Helmet>
        <title>
          Guaranteed Certification Success: Unlock Potential with DirectCertify
        </title>
        <meta
          name="description"
          content="Discover your true potential with DirectCertify. Our platform offers expert certification programs to unlock new opportunities and elevate your success. Gain industry-recognized credentials and certify your skills for a brighter future. Start your journey today!"
        />
      </Helmet>
      <Box sx={{ mt: 10 }}>
        <Home />
        <About />
        <LandingPageContent />
        <ExamsSeciton loading={loading} exams={exams} />
        <StatisticsSection />
        <Reviews />
        <Blogs />
      </Box>
    </>
  );
}

export default LandingPage;
